import AgencyAddFunds from './components/AgencyAddFunds.js';
import connect from './connect';
import './assets/AgencyAddFunds.css';

export default connect(AgencyAddFunds);



// WEBPACK FOOTER //
// ./src/routes/AgencyAddFunds/index.js